const SESSION_KEY = 'sh_oturum_kodu';

function generateCode(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

export function getSessionCode(): string {
  let code = sessionStorage.getItem(SESSION_KEY);
  if (!code) {
    code = generateCode();
    sessionStorage.setItem(SESSION_KEY, code);
  }
  return code;
}

export default getSessionCode;